'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { FaWhatsapp, FaFacebookF, FaLinkedinIn, FaLink } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { MdEmail } from 'react-icons/md';
interface ArticleShareButtonsProps {
  slug: string;
  title?: string;
  className?: string;
}
const BASE_URL = 'https://www.dinamani.com';
const ArticleShareButtons: React.FC<ArticleShareButtonsProps> = t0 => {
  const $ = _c(37);
  const {
    slug,
    title: t1,
    className: t2
  } = t0;
  const title = t1 === undefined ? "" : t1;
  const className = t2 === undefined ? "" : t2;
  const [copied, setCopied] = useState(false);
  const articleUrl = `${BASE_URL}/${slug}`;
  const encodedUrl = encodeURIComponent(articleUrl);
  const encodedTitle = encodeURIComponent(title);
  const t3 = `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FaWhatsapp size={18} />;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== t3) {
    t5 = {
      name: "WhatsApp",
      url: t3,
      icon: t4,
      bgColor: "bg-[#25D366]",
      hoverColor: "hover:bg-[#1da851]"
    };
    $[1] = t3;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FaXTwitter size={18} />;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== t6) {
    t8 = {
      name: "X",
      url: t6,
      icon: t7,
      bgColor: "bg-black",
      hoverColor: "hover:bg-gray-800"
    };
    $[4] = t6;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const t9 = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
  let t10;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FaFacebookF size={18} />;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  let t11;
  if ($[7] !== t9) {
    t11 = {
      name: "Facebook",
      url: t9,
      icon: t10,
      bgColor: "bg-[#1877F2]",
      hoverColor: "hover:bg-[#0d65d9]"
    };
    $[7] = t9;
    $[8] = t11;
  } else {
    t11 = $[8];
  }
  const t12 = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}`;
  let t13;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <FaLinkedinIn size={18} />;
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  let t14;
  if ($[10] !== t12) {
    t14 = {
      name: "LinkedIn",
      url: t12,
      icon: t13,
      bgColor: "bg-[#0A66C2]",
      hoverColor: "hover:bg-[#084d94]"
    };
    $[10] = t12;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  const t15 = `mailto:?subject=${encodedTitle}&body=${encodedUrl}`;
  let t16;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <MdEmail size={18} />;
    $[12] = t16;
  } else {
    t16 = $[12];
  }
  let t17;
  if ($[13] !== t15) {
    t17 = {
      name: "Email",
      url: t15,
      icon: t16,
      bgColor: "bg-[#EA4335]",
      hoverColor: "hover:bg-[#d33426]"
    };
    $[13] = t15;
    $[14] = t17;
  } else {
    t17 = $[14];
  }
  let t18;
  if ($[15] !== t11 || $[16] !== t14 || $[17] !== t17 || $[18] !== t5 || $[19] !== t8) {
    t18 = [t5, t8, t11, t14, t17];
    $[15] = t11;
    $[16] = t14;
    $[17] = t17;
    $[18] = t5;
    $[19] = t8;
    $[20] = t18;
  } else {
    t18 = $[20];
  }
  const shareLinks = t18;
  let t19;
  if ($[21] !== articleUrl) {
    t19 = async () => {
      ;
      try {
        await navigator.clipboard.writeText(articleUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (t20) {
        const err = t20;
        console.error("Failed to copy:", err);
      }
    };
    $[21] = articleUrl;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  const handleCopyLink = t19;
  const t20 = `flex flex-row items-center gap-1 p-3 ${className}`;
  let t21;
  if ($[23] !== shareLinks) {
    t21 = shareLinks.map(_temp);
    $[23] = shareLinks;
    $[24] = t21;
  } else {
    t21 = $[24];
  }
  const t22 = copied ? "Copied!" : "Copy Link";
  const t23 = `${copied ? "bg-green-600" : "bg-[#128C7E]"} hover:bg-[#0d6e63] text-white w-9 h-9 rounded flex items-center justify-center transition-all hover:scale-110`;
  let t24;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <FaLink size={18} />;
    $[25] = t24;
  } else {
    t24 = $[25];
  }
  let t25;
  if ($[26] !== handleCopyLink || $[27] !== t22 || $[28] !== t23) {
    t25 = <button onClick={handleCopyLink} title={t22} className={t23}>{t24}</button>;
    $[26] = handleCopyLink;
    $[27] = t22;
    $[28] = t23;
    $[29] = t25;
  } else {
    t25 = $[29];
  }
  let t26;
  if ($[30] !== copied) {
    t26 = copied && <span className="text-xs text-green-600 ml-1">Copied!</span>;
    $[30] = copied;
    $[31] = t26;
  } else {
    t26 = $[31];
  }
  let t27;
  if ($[32] !== t20 || $[33] !== t21 || $[34] !== t25 || $[35] !== t26) {
    t27 = <div className={t20}>{t21}{t25}{t26}</div>;
    $[32] = t20;
    $[33] = t21;
    $[34] = t25;
    $[35] = t26;
    $[36] = t27;
  } else {
    t27 = $[36];
  }
  return t27;
};
export default ArticleShareButtons;
function _temp(link) {
  return <a key={link.name} href={link.url} target="_blank" rel="noopener noreferrer" title={`Share on ${link.name}`} className={`${link.bgColor} ${link.hoverColor} text-white w-9 h-9 rounded flex items-center justify-center transition-all hover:scale-110`}>{link.icon}</a>;
}